/* eslint-disable */

import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';
import Lightbox from 'lightbox2';

const gallerySwiper = {

	init() {
		this.setSwiper();
		this.setLightbox();
	},

	setSwiper() {
		const galleries = document.querySelectorAll('.gallery-swiper');

		galleries.forEach(gallery => {
			const swiperContainer = gallery.querySelector('.swiper');

			const paginationEl = gallery.querySelector('.swiper-pagination');
			const nextEl = gallery.querySelector('.swiper-button-next');
			const prevEl = gallery.querySelector('.swiper-button-prev');

			new Swiper(swiperContainer,
				{
					modules: [Navigation, Pagination],
					loop: true,
					slidesPerView: 1,
					autoHeight: true,

					pagination: {
						el: paginationEl,
						clickable: true
					},

					navigation: {
						nextEl: nextEl,
						prevEl: prevEl,
					}
				}
			);

		})
	},

	setLightbox() {
		const timing = 300;

		Lightbox.option({
			disableScrolling: true,
			fadeDuration: timing,
			imageFadeDuration: timing,
			resizeDuration: timing,
			wrapAround: true,
			albumLabel: ''
		})
	}
}


if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', gallerySwiper.init());
} else {
	gallerySwiper.init();
}
